import React from "react";
import { Card } from "react-bootstrap";
import styled from "styled-components";

import { ErrorIcon } from "./core/icons";

const NotFoundCard = (): JSX.Element => {
    return (
        <Card className="mt-5 border-0">
            <Card.Body className="p-4">
                <div className="text-center py-3">
                    <StyledErrorIcon className="text-primary mb-2" />
                    <p className="text-label-grey mb-0">Page not found</p>
                </div>
            </Card.Body>
        </Card>
    );
};

const StyledErrorIcon = styled(ErrorIcon)`
    width: 48px;
    height: 48px;
`;

export default NotFoundCard;
